type Pair = {
    [key: string]: string;
};

export const STORES = [
    'STEELES',
    'WEB',
    'SC SuperStore',
    'Brampton',
    'SVP NM',
    'ORFUS',
    'VAUGHAN',
    'SVP QW',
    'Kingston',
    'Kitchener',
    'Whitby',
    'NIAGARA',
    'ALLISTON',
    'BARRIE',
    'BURLINGTON',
    'PICKERING-OUTLET',
    'OPM-Aurora',
    'OPM-Online'
];

export const STORES_PAIRS: Pair = {
    'STEELES': 'ST',
    'WEB': 'WEB',
    'SC SuperStore': 'SCS',
    'Brampton': 'Brampton',
    'SVP NM': 'SVP NM',
    'ORFUS': 'ORFUS',
    'VAUGHAN': 'V',
    'SVP QW': 'SVP QW',
    'Kingston': 'KNG',
    'Kitchener': 'Kitchener',
    'Whitby': 'Whitby',
    'NIAGARA': 'NF',
    'ALLISTON': 'AL',
    'BARRIE': 'BARRIE',
    'BURLINGTON': 'BURLINGTON',
    'PICKERING-OUTLET': 'NEW-PC',
    'OPM-Aurora': 'OPM-Aurora',
    'OPM-Online': 'OPM-Online',
    'Sample': 'Sample'
}

export const RMS_STORE_PAIRS: Pair = {
    "DC": 'DC',
    "DC-Caledonia": 'DC-CAL',
    "Steeles": "ST",
    "Web": "WEB",
    "Scarborough": "SCS",
    "Brampton": "BR",
    "Newmarket": 'SVP NM',
    "Dufferin-Orfus": "ORFUS",
    "Vaughan": "V",
    "Queensway": 'QW',
    "Kingston": "KNG",
    'Kitchener': 'Kitchener',
    'Whitby': 'Whitby',
    "Niagara": "NF",
    "Alliston": "AL",
    "Burlington": "BU",
    "OPM-Hamilton": "OHAM",
    "Pickering-Outlet": "New-PC",
    'Barrie': 'BARRIE',
    'OPM-Aurora': 'OPM-Aurora',
    'OPM-Online': 'OPM-Online',
    'Sample': 'Sample'
}

export const DOORS: { [key: string]: string[] } = {
    'GYM': ['WEB', 'SC SuperStore', 'Brampton', 'SVP NM', 'SVP QW', 'NIAGARA'],
    'HOCKEY': ['WEB', 'VAUGHAN', 'NIAGARA', 'ALLISTON', 'OPM-HAMILTON'],
    'SOCCER': ['WEB', 'SC SuperStore', 'Brampton', 'VAUGHAN', 'SVP QW', 'CARTWRIGHT'],
    'GOLF': ['WEB', 'VAUGHAN', 'SVP QW', 'Kingston', 'NIAGARA', 'ALLISTON', 'OPM-HAMILTON'],
}

export const URL_PREFIX = '';